import React from 'react';
import * as styles from './index.module.scss';
import CopyButton from './components/copiedButton';
import useIsMobile from '../../../hooks/useIsMobile';

export default () => {
  const isMobile = useIsMobile();
  return (
    <div className={styles.whatIs} id="whatIs">
      <div className={styles.title}>What is MTT Token？</div>
      <div className={styles.desc}>
        The MTT Token is a Utility Token issued by the MTT Foundation on the
        Ethereum mainnet, based on the ERC-20 protocol. It has a maximum supply
        of 2.1 billion tokens, with the <span>Contract Address</span>
      </div>
      <div className={styles.copySection}>
        {isMobile ? (
          <i>0x0FC223994e0d...60a238</i>
        ) : (
          <i>0x0FC223994e0de0a0F952D775Ef00B0389e60a238</i>
        )}
        {/* <span className={styles.copyBtn}>
          <img
            src="https://cdn-web.mtt.xyz/static/cube-alt-1.png"
            alt=""
          />
        </span> */}
        <CopyButton textToCopy="0x0FC223994e0de0a0F952D775Ef00B0389e60a238" />
      </div>
    </div>
  );
};
